import { render, staticRenderFns } from "./StrategyDetailPage.vue?vue&type=template&id=6cdcefc0&scoped=true"
import script from "./StrategyDetailPage.vue?vue&type=script&lang=js"
export * from "./StrategyDetailPage.vue?vue&type=script&lang=js"
import style0 from "./StrategyDetailPage.vue?vue&type=style&index=0&id=6cdcefc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcefc0",
  null
  
)

export default component.exports